import React from 'react';

function PageHeader({ breadcrumbs = [], title, actionButton, secondaryActionButton, tertiaryActionButton }) {
  return (
    <div className="admin-page-header">
      <div className="header-content">
        <div className="header-left">
          {breadcrumbs.length > 0 && (
            <div className="breadcrumbs">
              {breadcrumbs.map((crumb, index) => (
                <span key={index} className="breadcrumb-item">
                  {crumb}
                  {index < breadcrumbs.length - 1 && <span className="breadcrumb-sep">›</span>}
                </span>
              ))}
            </div>
          )}
          {title && <h2 className="page-title">{title}</h2>}
        </div>
        <div className="header-right">
          {actionButton && (
            <div className="header-action">
              {actionButton}
            </div>
          )}
          {secondaryActionButton && (
            <div className="header-action">
              {secondaryActionButton}
            </div>
          )}
          {tertiaryActionButton && (
            <div className="header-action">
              {tertiaryActionButton}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PageHeader;


